import { Core } from "@faire/design-tokens";
import { Upload } from "@faire/web--source/slate/icons/foundation/Upload";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React, { type JSX } from "react";

interface IProps {
  uploadCta?: string | JSX.Element;
  isLoading?: boolean;
  error?: boolean;
  showFileIcon?: boolean;
}

export const FileUploaderStatus: React.FC<IProps> = ({
  uploadCta,
  isLoading = false,
  error = false,
  showFileIcon = true,
}) => {
  if (isLoading) {
    return (
      <>
        <LoadingSpinner color={Core.icon.subdued} />
        {uploadCta ? <LoadingMessage /> : null}
      </>
    );
  }

  return (
    <>
      {showFileIcon ? <Upload color="inherit" fontSize="24px" /> : null}
      {uploadCta ? (
        <>
          <Spacer size="1x" />
          {typeof uploadCta === "string" ? (
            <Typography
              color={error ? Core.text.critical : "inherit"}
              align="center"
            >
              {uploadCta}
            </Typography>
          ) : (
            <>{uploadCta}</>
          )}
        </>
      ) : null}
    </>
  );
};

const LoadingMessage: React.FC = () => {
  return (
    <>
      <Spacer size="1x" />
      <Typography color="inherit" align="center">
        <StrictLocalMsg
          defaultMessage="Uploading..."
          description={{
            text: "Indicates that a file is currently uploading",
          }}
        />
      </Typography>
    </>
  );
};
